import { IColumnDefinition } from "./index"

export const getDefaultColumnWidth = (
    column: IColumnDefinition,
    defaultWidth = 200,
): number => {
    switch (column.fieldId) {
        case "SF1":
            return defaultWidth / 3
        case "SF2":
            return defaultWidth * 4
    }

    switch (column.fieldType) {
        case "LongText":
        case "BigText":
        case "RTF":
            return defaultWidth * 4
        case "Text":
            return defaultWidth * 2
        case "Date":
        case "SingleSelect":
        case "MultiSelect":
            return defaultWidth
        case "Number":
        case "Time":
            return defaultWidth / 2
        case "Checkbox":
            return defaultWidth / 4
        default:
            return defaultWidth
    }
}
